<template>
  <div class="demand">
    <div class="searchPart">
      <el-input v-model="enterPriseName" placeholder="服务商名称"></el-input>
      <!--<el-select v-model="serviceSector" placeholder="服务行业">
        <el-option label="草稿" value="DRAFT"> </el-option>
        <el-option label="待审核" value="AUDIT"> </el-option>
        <el-option label="审核通过" value="PASS"> </el-option>
        <el-option label="审核拒绝" value="REJECT"> </el-option>
      </el-select>-->
      <!--<el-input v-model="serverAdd" placeholder="服务商地址"></el-input>-->
      <el-button class="searchBtn" @click="search">搜索</el-button>
      <el-button type="text" class="resetBtn" @click="reset">
        <i class="iconfont icon-qingchushujuku"></i>
        <span>清除条件</span>
      </el-button>
    </div>
    <div class="tablePart">
      <div class="tableTool">
        <div class="toolLeft">
          <span
            >已选： <span class="num">{{ demandSelection.length }}</span></span
          >
          <el-button
            type="primary"
            plain
            size="small"
            @click="removeFollow('all')"
            >批量取消</el-button
          >
        </div>
      </div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        @selection-change="handleSelectionChange"
        class="tableContent"
      >
        <el-table-column
          type="selection"
          header-align="center"
          align="center"
          width="55"
        >
        </el-table-column>
        <el-table-column
          prop="enterPriseName"
          label="服务商名称"
          header-align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div class="printImgsName">
              <img :src="scope.row.shopLogo" alt="" v-if="scope.row.shopLogo!=''"/>
              <img src="@/assets/images/服务商_画板 1.jpg" alt="" v-else/>
              <div class="printImgsNameMess">
                <h4 style="cursor: pointer;" @click="handleDesigner(scope.row)">{{ scope.row.enterPriseName }}</h4>
                <!--<div class="printImgsNameMessNum">
                  <i class="el-icon-box"></i>
                  <p v-for="(items,index) in scope.row.serveClass" :key="index">{{items}}</p>
                </div>-->
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="serviceCount"
          label="服务数量"
          header-align="center"
          align="center"
          width="160"
        >
        </el-table-column>
        <el-table-column
          prop="goodsCount"
          label="商品数量"
          header-align="center"
          align="center"
          width="160"
        >
        </el-table-column>
        <el-table-column
          prop="type"
          label="类型"
          header-align="center"
          align="center"
          width="160"
        >
        </el-table-column>
        <el-table-column
          prop="address"
          label="地址"
          header-align="center"
          align="center"
          :formatter="updateAddress"
          width="400"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="230"
        >
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="removeFollow(scope.row)">取消关注</el-button>
          </template>
        </el-table-column>
         <template slot="empty">
          <img src="../../assets/暂无关注.jpg" alt="" style="width:200px">
        </template>
      </el-table>
      <el-pagination
        background
        @current-change="handleCurrentChange"
        @prev-click="handleCurrentChange"
        @next-click="handleCurrentChange"
        layout="total,prev, pager, next,jumper"
        :current-page="current"
        :page-size="pageSize"
        :total="total"
        class="pagination"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getPrintFollowList,removeFollow } from '../../utils/interface';
export default {
  data() {
    return {
        form: {},
        enterPriseName: "",
        serverAdd: "",
        serviceSector: "",
        tableData: [],
        current: 0,
        pageSize: 10,
        total: 0,
        demandSelection: [],
    };
  },
    created(){
      this.getPrintFollowList();
    },
  methods: {
      handleDesigner(item){
          let uuid = "/" + item.enterPriseUuid;
          let enterPriseId = "/" + item.enterPriseId;
          window.open(
              this.$url.threeWeb + '/printServiceIndex' + enterPriseId,
              "_blank"
          );
      },
      updateAddress(row, column){
          if(row.address==null){
              return row.paddress;
          }else{
              return row.address;
          }
      },
      getPrintFollowList(){
          let params = {
              enterPriseName:this.enterPriseName,
              current:this.current,
              pageSize:this.pageSize,
              isBuy:true,
          }
          getPrintFollowList(params).then((res)=>{
              this.total = res.total;
              this.tableData = res.list;
          });
      },
    // 清除检索条件
    reset() {
      this.enterPriseName = "";
    },
    // 分页
    handleCurrentChange(val) {
        this.current = val;
        this.getPrintFollowList();
    },
    // 复选框选中值
    handleSelectionChange(val) {
      this.demandSelection = val;
    },
    search() {
        this.current = 1;
        this.getPrintFollowList();
    },
      removeFollow(item){
          let ids = '';
          if(item === 'all'){
              ids = this.demandSelection.map((item)=>{
                  return item.uuid
              }).toString()
          } else {
              ids = item.uuid;
          }
          this.$confirm('确定要取消关注吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
              removeFollow({uuid:ids}).then((res)=>{
                  if(res.success){
                      this.$message.success('取消成功!');
                      this.getPrintFollowList();
                  }
              });
          });
      },
  },
};
</script>

<style scoped lang="less">
.demand {
  padding: 20px;

  .releaseBox {
    background: #fff;
    padding: 35px;
    padding-top: 0;
    box-sizing: border-box;
    .releaseBoxTop {
      margin-bottom: 15px;
      h4 {
        font-size: 18px;
        color: #157efa;
        margin-bottom: 18px;
      }
      .releaseBoxTopInput {
        font-size: 14px;
        color: #262626;
        align-items: center;
        margin-bottom: 20px;
        /deep/.ql-toolbar.ql-snow {
          display: none;
        }
        /deep/.ql-toolbar.ql-snow + .ql-container.ql-snow {
          border-top: 1px solid #ccc;
        }
        .releaseBoxTopInputBox {
          flex-wrap: wrap;
        }
        input {
          height: 30px;
          background: #f5f5f5;
          border-radius: 4px;
          border: none;
          padding-left: 8px;
          box-sizing: border-box;
        }
        .input2 {
          width: 161px;
          // margin-left: 90px;
        }
        textarea {
          width: 614px;
          height: 206px;
          background: #f5f5f5;
          opacity: 1;
          border-radius: 6px;
          border: none;
          padding: 8px;
          box-sizing: border-box;
        }
        /deep/.el-input--prefix .el-input__inner {
          width: 161px;
          height: 30px;
          background: #f5f5f5;
          border-radius: 4px;
          border: none;
          //   padding-left: 8px;
          box-sizing: border-box;
          //   margin-left: 25px;
        }
        // /deep/.el-input__prefix {
        //   right: -132px;
        //   left: 0;
        // }
        /deep/.el-input__icon {
          line-height: 30px;
        }
        .releaseBoxbotInputP {
          width: 94px;
          flex-shrink: 0;
          white-space: nowrap;
        }
        .releaseBut {
          background: #157efb;
          color: #fff;
        }
        button {
          width: 100px;
          height: 30px;
          background: #f5f5f5;
          border-radius: 4px;
          border: none;
          margin-right: 20px;
          color: #262626;
          font-size: 14px;
          cursor: pointer;
        }
      }
    }
  }

  .searchPart {
    display: flex;
    flex-wrap: wrap;

    /deep/ .el-input {
      width: initial;
      margin-bottom: 22px;
      margin-right: 30px;
    }

    /deep/ .el-input__inner {
      width: 242px;
      height: 35px;
      min-height: 35px;
      font-size: 12px;
      color: #999999;
      background-color: #f2f4f7;
      border: 1px solid #f2f4f7;
      border-radius: 5px;

      &:hover,
      &:focus {
        background-color: #fff;
        border: 1px solid #108ee9;
      }
    }

    /deep/ .el-input__prefix {
      top: -3px;
    }

    /deep/ .el-input__suffix {
      top: 2px;
    }

    /deep/ .el-button {
      display: block;
      line-height: 35px;
      padding: 0;
      height: 35px;
    }

    .searchBtn {
      width: 82px;
      background: #3d7fff;
      border: none;
      border-radius: 15px;
      font-size: 14px;
      color: #ffffff;
      margin-bottom: 22px;
    }

    .resetBtn {
      color: #333333;
      margin-bottom: 22px;
    }
  }

  .tablePart {
    .tableTool {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;

      .toolLeft {
        font-size: 12px;
        color: rgba(0, 0, 0, 0.847);

        .num {
          color: #356fdf;
        }

        button {
          padding: 0;
          margin-left: 15px;
          width: 80px;
          height: 30px;
          background: rgba(242, 244, 247, 1);
          box-sizing: border-box;
          border: 1px solid rgba(21, 126, 251, 1);
          border-radius: 5px;
          font-size: 12px;
          color: #157efb;
          line-height: 30px;
          text-align: center;

          &:hover {
            background: #157efb;
            box-sizing: border-box;
            border: 1px solid #157efb;
            color: #fff;
          }
        }
      }

      .toolRight {
        button {
          width: 83px;
          height: 30px;
          background: rgba(21, 126, 251, 1);
          border: none;
          border-radius: 15px;
          font-size: 13px;
          color: #fff;

          i {
            padding-right: 5px;
          }

          &:hover {
            background: #61a2f0;
          }
        }
      }
    }

    .tableContent {
      min-height: 650px;
      .printImgsName {
        display: flex;
        align-items: center;
        img {
          margin-right: 10px;
          width: 50px !important;
          height: 50px !important;
          //border-radius: 50%;
        }
        .printImgsNameMess {
          h4 {
            margin: 0;
            //color: #108ee9;
          }
          p {
            margin: 0;
          }
          .printImgsNameMessNum {
            display: flex;
            align-items: center;
            margin-top: 10px;
            i {
              color: #108ee9;
              margin-right: 8px;
            }
            p {
              margin-right: 8px;

            }
          }
        }
      }
      /deep/ .el-table__header {
        tr {
          th {
            border-right: none;
          }
        }

        /deep/ .el-table__cell {
          padding: 5px 0;
          background: #f2f5fc;
        }
      }

      /deep/ .el-table__body {
        img {
          vertical-align: middle;
          width: 52px;
          height: 50px;
        }

        /deep/ .el-table__row {
          td:first-child {
            border-right: none;

            .cell {
              padding-left: 15px;
            }
          }
        }
      }
    }

    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
}
/deep/.el-dialog__body {
  padding-top: 0;
}
.itemFlex {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
  .name {
    margin-left: 10px;
    /deep/p {
      margin: 0 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/focusOn/serviceProviders.vue